window.hgDtfPrint = async function (layout, inches, progress) {
  const width = 6600, height = inches * 300;
  if (!window.CompressionStream) throw Error('Please use a current Chrome, Edge or Safari browser to prepare your print file.');
  function crc(bytes) {
    let c = 0xffffffff;
    for (const b of bytes) { c ^= b; for (let k = 0; k < 8; k++) c = (c >>> 1) ^ ((c & 1) ? 0xedb88320 : 0); }
    return (c ^ 0xffffffff) >>> 0;
  }
  function chunk(name, bytes) {
    const output = new Uint8Array(bytes.length + 12), view = new DataView(output.buffer);
    view.setUint32(0, bytes.length);
    output.set([...name].map(c => c.charCodeAt(0)), 4);
    output.set(bytes, 8);
    view.setUint32(output.length - 4, crc(output.subarray(4, output.length - 4)));
    return output;
  }
  const compressor = new CompressionStream('deflate'), writer = compressor.writable.getWriter();
  const compressed = new Response(compressor.readable).arrayBuffer();
  const canvas = document.createElement('canvas'); canvas.width = width;
  const ctx = canvas.getContext('2d', {willReadFrequently: true});
  try {
    for (let y = 0; y < height; y += 128) {
      const rows = Math.min(128, height - y); canvas.height = rows;
      for (const n of layout) if (n.y * 300 < y + rows && (n.y + n.h) * 300 > y)
        ctx.drawImage(n.asset.img, n.x * 300, n.y * 300 - y, n.w * 300, n.h * 300);
      const rgba = ctx.getImageData(0, 0, width, rows).data, stride = width * 4;
      const scanlines = new Uint8Array((stride + 1) * rows);
      for (let r = 0; r < rows; r++) scanlines.set(rgba.subarray(r * stride, (r + 1) * stride), r * (stride + 1) + 1);
      await writer.write(scanlines);
      if (progress) progress(Math.round((y + rows) / height * 100));
    }
    await writer.close();
    const image = new Uint8Array(await compressed), header = new Uint8Array(13), hv = new DataView(header.buffer);
    hv.setUint32(0, width); hv.setUint32(4, height); header[8] = 8; header[9] = 6;
    const density = new Uint8Array(9), dv = new DataView(density.buffer);
    dv.setUint32(0, 11811); dv.setUint32(4, 11811); density[8] = 1;
    return new Blob([new Uint8Array([137,80,78,71,13,10,26,10]),chunk('IHDR',header),chunk('pHYs',density),chunk('IDAT',image),chunk('IEND',new Uint8Array())],{type:'image/png'});
  } catch (error) { await writer.abort(error).catch(() => {}); await compressed.catch(() => {}); throw error; }
  finally { canvas.width = canvas.height = 1; }
};
